var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "visitor-profile-desktop" }, [
    _c("div", { staticClass: "visitor-profile-desktop-inner" }, [
      _c("div", { staticClass: "visitor-profile-desktop-particle" }),
      _vm._v(" "),
      _c("div", { staticClass: "visitor-profile-desktop-avatar-wrapper" }, [
        _c("img", {
          staticClass: "visitor-profile-desktop-avatar",
          attrs: { src: _vm.userAvatar, alt: _vm.getUserData("name") },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "visitor-profile-desktop-data" }, [
        _c(
          "div",
          { staticClass: "visitor-profile-desktop-data-title-wrapper" },
          [
            _c("h2", { staticClass: "visitor-profile-desktop-data-title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.getUserData("name") || _vm.$t("Agent")) +
                  "\n        "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "visitor-profile-desktop-data-text-wrapper" },
          [
            _c("p", { staticClass: "visitor-profile-desktop-data-text" }, [
              _c("i", { staticClass: "isif isif-brief-case" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "visitor-profile-desktop-data-text-icon-divider",
              }),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "visitor-profile-desktop-data-text-ellipsis" },
                [
                  _vm._v(
                    _vm._s(
                      _vm.getUserData("companyDisplayName") || _vm.$t("None")
                    )
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "visitor-profile-desktop-data-text" }, [
              _c("i", { staticClass: "isif isif-phone" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "visitor-profile-desktop-data-text-icon-divider",
              }),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "visitor-profile-desktop-data-text-ellipsis" },
                [_vm._v(_vm._s(_vm.getUserData("phone") || _vm.$t("None")))]
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "visitor-profile-desktop-data-text" }, [
              _c("i", { staticClass: "isif isif-drawer" }),
              _vm._v(" "),
              _c("span", {
                staticClass: "visitor-profile-desktop-data-text-icon-divider",
              }),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "visitor-profile-desktop-data-text-ellipsis" },
                [_vm._v(_vm._s(_vm.getUserData("email") || _vm.$t("None")))]
              ),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }